import { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';

export const storage = {
  get: (key, defaultValue = false) => {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (err) {
      return defaultValue;
    }
  },
  set: (key, value) => {
    const newValue = JSON.stringify(value);
    localStorage.setItem(key, newValue);
  },
  remove: (key) => {
    localStorage.removeItem(key);
  },
};

export const usePersistState = (
  key,
  state,
  config = { keepOnUnmount: true }
) => {
  const [value, setValue] = useState(storage.get(key) || state);
  const handleSet = useCallback(
    (v) => {
      setValue(v);
      window.dispatchEvent(new Event(`storage-${key}`));
    },
    [setValue, key]
  );
  // eslint-disable-next-line
  const updateState = useCallback(
    debounce((newState) => {
      storage.set(key, newState);
    }, 300),
    []
  );
  useEffect(() => {
    updateState(value);
  }, [value]); // eslint-disable-line
  useEffect(
    () => () => {
      if (!config.keepOnUnmount) {
        storage.remove(key);
      }
    },
    [] // eslint-disable-line
  );
  return [value, handleSet];
};
